import React, { useContext } from "react";
import GameContext from "../../Context";
import { Step } from "../../../../types/GameTypes";

import "./Cell.scss";

import cellVacant from "./cell-vacant.gif";
import cellBallGuess from "./cell-ball-guess.gif";
import cellBallMissed from "./ball-missed.gif";
import cellBallWrong from "./ball-wrong.gif";
import cellBallCorrect from "./ball-correct.gif";
import GameBoardCellMovement from "./Movement";

type Props = {
  x: number;
  y: number;
  hasGuess: boolean;
  hasBall: boolean;
  pathActive: boolean;
  steps: Array<Step> | undefined;
};

function GameBoardCell({ x, y, hasGuess, hasBall, steps, pathActive }: Props) {
  const { engine } = useContext(GameContext);

  const styles = {
    gridColumnStart: x + 2,
    gridColumnEnd: x + 3,
    gridRowStart: y + 2,
    gridRowEnd: y + 3,
  };

  const handleClick = async () => {
    if (engine.isRunning()) {
      engine.toggleGuessAt({ x, y });
    }
  };

  const cell = engine.isRunning()
    ? hasGuess
      ? cellBallGuess
      : cellVacant
    : hasGuess
    ? hasBall
      ? cellBallCorrect
      : pathActive
      ? cellVacant
      : cellBallWrong
    : hasBall
    ? cellBallMissed
    : cellVacant;

  return (
    <div className={`cell cell-${x}-${y}`} style={styles} onClick={handleClick}>
      <img className="cell" src={cell} width="100%" alt="cell" />
      {pathActive &&
        steps &&
        steps.map((step) => <GameBoardCellMovement key={JSON.stringify(step)} step={step!} />)}
    </div>
  );
}

export default GameBoardCell;
